import { IndicatorType } from '../configs/indicators.config';
import { SurveySelectedType } from '../configs/types';
import _orderBy from 'lodash/orderBy';

/**
 * Filters and sorts the admin2 data based on the selected indicator, all surveys, and the survey selected.
 * @param {IndicatorType} indicatorSelected - the selected indicator
 * @param {Object} allSurveys - all the surveys
 * @param {SurveySelectedType | null} surveySelected - the selected survey
 * @returns {Array} - the filtered and sorted admin2 data
 */
export function getAdmin2dataFilteredSorted(
  indicatorSelected: IndicatorType,
  allSurveys: any,
  surveySelected: SurveySelectedType | null
) {
  const indicatorID = indicatorSelected.value;
  const admin2dataFiltered = allSurveys.filter((survey: any) => {
    return (
      survey.attributes.IndicatorID === indicatorID &&
      survey.attributes.DHSCC === surveySelected?.DHSCC &&
      survey.attributes.year === surveySelected?.year
    );
  });

  return _orderBy(admin2dataFiltered, ['attributes.adm2_name']);
}

/**
 * Get level rank based on the country code
 * @param {string} countryCode - the country code
 * @returns {number} - the level rank (1 or 2)
 */
export function getLevelRank(countryCode: string) {
  return ['LB', 'NG'].includes(countryCode) ? 2 : 1;
}
